// UI strings shown on the customer menu page, keyed by language.
// English values are the source of truth - missing translations fall
// back to the English string via STRINGS.en[key].
//
// Translation status (2026-06-05):
//   AM — REVIEWED (review sheet) except offline strings (DRAFT).
//   OM — REVIEWED; review-sheet corrections applied 2026-06-05
//        (Ida'ama, Ergamaa jira…, Meenuun…). Offline strings DRAFT.
//   TI — MACHINE DRAFT, full set. Native review pending.
//   SID — MACHINE DRAFT, LOW CONFIDENCE. Native review required
//         before the Hawassa pilot.
//   NL — drafted (high confidence).
// Review sheet: docs/i18n/ODRA_Translation_Review.xlsx
export const STRINGS = {
  en: {
    loading_menu: "Loading menu…",
    your_order: "Your order",
    cart_empty: "Tap items above to add them to your order.",
    notes_placeholder: "Notes for the kitchen (optional)",
    total: "Total",
    submitting: "Submitting…",
    submit_order: "Submit order",
    table: "Table",
    add: "Add",
    remove: "Remove",
    no_items_yet: "No menu items yet.",
    out_of_stock: "Currently unavailable",
    // Offline-resilience strings (added 2026-06-05).
    offline_banner: "No connection — your cart is safe. We'll reconnect automatically.",
    reconnecting: "Reconnecting — still sending your order…",
    order_network_fail: "We couldn't reach the kitchen. Check your connection and tap Submit again — your cart is unchanged.",
  },
  nl: {
    loading_menu: "Menu laden…",
    your_order: "Jouw bestelling",
    cart_empty: "Tik op een gerecht om het toe te voegen.",
    notes_placeholder: "Opmerkingen voor de keuken (optioneel)",
    total: "Totaal",
    submitting: "Versturen…",
    submit_order: "Bestelling versturen",
    table: "Tafel",
    add: "Toevoegen",
    remove: "Verwijderen",
    no_items_yet: "Nog geen menu-items.",
    out_of_stock: "Momenteel niet beschikbaar",
    offline_banner: "Geen verbinding — je bestelling blijft bewaard. We verbinden automatisch opnieuw.",
    reconnecting: "Opnieuw verbinden — je bestelling wordt nog verstuurd…",
    order_network_fail: "We konden de keuken niet bereiken. Controleer je verbinding en tik nogmaals op Versturen — je bestelling is onveranderd.",
  },
  am: {
    loading_menu: "ሜኑ በመጫን ላይ…",
    your_order: "የእርስዎ ትዕዛዝ",
    cart_empty: "ለመጨመር ከላይ ያሉትን ዕቃዎች ይንኩ።",
    notes_placeholder: "ለኩሽና ማስታወሻ (አማራጭ)",
    total: "ድምር",
    submitting: "በመላክ ላይ…",
    submit_order: "ትዕዛዝ ላክ",
    table: "ጠረጴዛ",
    add: "ጨምር",
    remove: "አስወግድ",
    no_items_yet: "ምንም ሜኑ የለም።",
    out_of_stock: "በአሁኑ ጊዜ የለም",
    // DRAFT — offline strings pending review
    offline_banner: "የበይነመረብ ግንኙነት የለም — ትዕዛዝዎ እንደተጠበቀ ነው ። በራስ-ሰር እንደገና እንገናኛለን።",
    reconnecting: "እንደገና በመገናኘት ላይ — ትዕዛዝዎ በመላክ ላይ ነው…",
    order_network_fail: "ኩሽናውን ማግኘት አልቻልንም። ግንኙነትዎን ያረጋግጡና እንደገና «ላክ» ይንኩ — ትዕዛዝዎ አልተቀየረም።",
  },
  om: {
    loading_menu: "Meenuun fe'aat jira…",      // REVIEWED (was "Menuu fe'aa…")
    your_order: "Ajaja keessan",
    cart_empty: "Ajaja keessan irratti dabaluuf nyaata olii tuqaa.",
    notes_placeholder: "Yaadachiisa waaroodhaf (filannoo)", // REVIEWED
    total: "Ida'ama",                          // REVIEWED (was "Walumaa galatti")
    submitting: "Ergamaa jira…",               // REVIEWED (was "Ergamaa…")
    submit_order: "Ajaja ergi",
    table: "Minjaala",
    add: "Dabali",
    remove: "Haqi",
    no_items_yet: "Meenuun hin jiru.",         // REVIEWED (was "Menuu hin jiru.")
    out_of_stock: "Hin jiru",
    // DRAFT — offline strings pending review
    offline_banner: "Interneetin hin jiru — ajajni keessan akkumajirtti isin eega. Interneetidhaan walqunnamuuf yaalla.",
    reconnecting: "Deebinee walqunnamaa jirra — ajajni keessan ergamaat jira…",
    order_network_fail: "Kushiina bira gahuu hin dandeenye. Quunnamtii keessan mirkaneessaatii ammas Ergi tuqaa — ajajni keessan hin jijjiiramne.",
  },
  // Sidaamu Afoo (Af Sidama) — MACHINE DRAFT 2026-06-05, LOW
  // CONFIDENCE (low-resource language; loanword-heavy). Every value
  // must be verified by a native speaker before the Hawassa pilot.
  sid: {
    loading_menu: "Meenyu dirriqamanni no…",
    your_order: "Hajajokki",
    cart_empty: "Hajajokkira ledate aliidi uduunne xiiwi.",
    notes_placeholder: "Kishinete qaagiishsha (hasiisanno yannara)",
    total: "Xaphooma",
    submitting: "Soyamanni no…",
    submit_order: "Hajajo soyi",
    table: "Xaraphpheeza",
    add: "Ledi",
    remove: "Hooli",
    no_items_yet: "Geeshsha meenyu dino.",
    out_of_stock: "Xa dino",
    offline_banner: "Quunnamte dino — hajajokki agadhinoonni. Umonke higge xaandeemmo.",
    reconnecting: "Galagalle xaandeemmo — hajajokki soyamanni no…",
    order_network_fail: "Kishinete iillate didandiinoommo. Quunnamtekki buuxxe galagalte Soyi xiiwi — hajajokki diSoorrantino.",
  },
  // Tigrinya — MACHINE DRAFT 2026-06-05, full set. Native-speaker
  // review pending (see docs/i18n/ODRA_Translation_Review.xlsx).
  ti: {
    loading_menu: "ሜኑ ይጽዕን ኣሎ…",
    your_order: "ትእዛዝኩም",
    cart_empty: "ናብ ትእዛዝኩም ንምውሳኽ ኣብ ላዕሊ ዘለዉ ጠውቑ።",
    notes_placeholder: "ንኽሽነ መዘኻኸሪ (ኣማራጺ)",
    total: "ድምር",
    submitting: "ይለኣኽ ኣሎ…",
    submit_order: "ትእዛዝ ለኣኽ",
    table: "ጠረጴዛ",
    add: "ወስኽ",
    remove: "ኣልግስ",
    no_items_yet: "ገና ሜኑ የለን።",
    out_of_stock: "ሕጂ የለን",
    offline_banner: "ርክብ የለን — ትእዛዝኩም ተዓቂቡ ኣሎ። ባዕልና ዳግማይ ክንራኸብ ኢና።",
    reconnecting: "ዳግማይ ንራኸብ ኣለና — ትእዛዝኩም ይለኣኽ ኣሎ…",
    order_network_fail: "ናብ ክሽነ ክንበጽሕ ኣይከኣልናን። ርክብኩም ኣረጋግጹ እሞ ዳግማይ «ለኣኽ» ጠውቑ — ትእዛዝኩም ኣይተቐየረን።",
  },
};

export function makeT(lang) {
  return (key) =>
    (STRINGS[lang] && STRINGS[lang][key]) ||
    STRINGS.en[key] ||
    key;
}

// Dietary / allergen tag display config. The label is translated per
// language so guests at Gezena see "Veganistisch" and guests at Bole
// View see "ቪጋን". Color matches the manager UI so the tag chip looks
// the same across both apps.
// SID + TI labels are MACHINE DRAFTS (2026-06-05) pending native review.
// OM "spicy" corrected per review sheet (Mi'aawaa → Mi'eessitu).
export const TAG_LABELS = {
  vegan: { en: "Vegan", nl: "Veganistisch", am: "ቪጋን", om: "Veegaan", sid: "Veegaane", ti: "ቪጋን", color: "#1b6b1e", icon: "🌱" },
  vegetarian: { en: "Vegetarian", nl: "Vegetarisch", am: "ቬጀታሪያን", om: "Vegetariyaa", sid: "Vejetariyaane", ti: "ቨጀታርያን", color: "#3a8a3d", icon: "🥗" },
  fasting: { en: "Fasting", nl: "Vasten", am: "የጾም", om: "Kan Tsoomii", sid: "Soomate", ti: "ናይ ጾም", color: "#5a7a3d", icon: "🙏" },
  gluten_free: { en: "Gluten-free", nl: "Glutenvrij", am: "ግሉተን-የለሽ", om: "\"Gilutan\" kan hin qabne", sid: "Gluteeni nookkiha", ti: "ብዘይ ግሉተን", color: "#a6611a", icon: "🌾" },
  dairy_free: { en: "Dairy-free", nl: "Lactosevrij", am: "ወተት-የለሽ", om: "Aannan kan hin qabne", sid: "Ado nookkiha", ti: "ብዘይ ጸባ", color: "#5a4fcf", icon: "🥛" },
  nut_free: { en: "Nut-free", nl: "Notenvrij", am: "ለውዝ-የለሽ", om: "Akakii kan hin qabne", sid: "Ocholoni nookkiha", ti: "ብዘይ ለውዝ", color: "#8a5a00", icon: "🥜" },
  halal: { en: "Halal", nl: "Halal", am: "ሐላል", om: "Halaala", sid: "Halaale", ti: "ሓላል", color: "#1a7a6b", icon: "" },
  kosher: { en: "Kosher", nl: "Kosjer", am: "ኮሸር", om: "Kosheer", sid: "Koshere", ti: "ኮሸር", color: "#3a6db8", icon: "" },
  spicy: { en: "Spicy", nl: "Pittig", am: "ቅመም", om: "Mi'eessitu", sid: "Barbare noosiha", ti: "በርበረ ዘለዎ", color: "#b13c38", icon: "🌶" },
  contains_alcohol: { en: "Alcohol", nl: "Alcohol", am: "አልኮል", om: "Alkoolii", sid: "Alkoole", ti: "ኣልኮል", color: "#6b3a8a", icon: "🍷" },
};
export const TAG_ORDER = [
  "vegan", "vegetarian", "fasting", "gluten_free", "dairy_free",
  "nut_free", "halal", "kosher", "spicy", "contains_alcohol",
];

// Language picker display labels. Admin ticks language checkboxes in
// TenantSettingsPage, customer sees them in the picker in the order
// returned by the backend.
export const LABELS = {
  en:  { code: "en",  label: "EN" },
  am:  { code: "am",  label: "አማ" },
  om:  { code: "om",  label: "AO" },
  sid: { code: "sid", label: "A-Sid" },   // Sidaamu Afoo
  ti:  { code: "ti",  label: "ትግ" },     // Tigrinya — added June 2026
  nl:  { code: "nl",  label: "NL" },
};

// Legacy country-based language defaults, used when the backend doesn't
// return an explicit ``supported_languages`` list for the tenant.
export const COUNTRY_DEFAULTS = {
  NL:    ["en", "nl"],
  ET:    ["en", "am", "om"],
  OTHER: ["en"],
};
